
const BASE_URL = 'https://www.mucheco.com/admin_mucheco/';
export const basename='/';
// export const basename='/ukmucheco';

export const WB_URL = 'https://www.mucheco.com/'
// const BASE_URL = 'http://54.67.56.126/ebsMntTst/muchecoTest/new_mucheco_react/admin_mucheco/';
// export const basename='/ebsMntTst/muchecoTest/new_mucheco_react/#';
// export const basename='/mucheco_react/#';
// export const basename='new.mucheco.com';
// const BASE_URL = 'http://88.208.224.110/mucheco_react/admin';
// const BASE_URL = 'http://192.168.10.124/admin_mucheco';
// const BASE_URL = 'http://54.67.90.94/ukmucheco/admin_mucheco';
// export const basename='/mucheco_react/';


export const API = {
    PORTFOLIO: BASE_URL + '/api/portfolio.php',
    SERVICE_DETAILS:BASE_URL+'/api/service_details.php',
    ADMINLOGIN:BASE_URL+'/api/login.php',
    INSIGHT_UPLOAD:BASE_URL+"/api/insights_details.php",
    INSIGHT_PAGE:BASE_URL+"/api/insights_details.php",
    CONTACT_US:BASE_URL+"/api/contact_us.php",
    ALL_PAGE_METATAG:BASE_URL+"/api/get-meta-tags.php",
    CONSULTANCY:BASE_URL+"/api/consultancy.php",
    ABOUT_US:BASE_URL+"/api/about-us.php",
    FAQ:BASE_URL+"/api/faq.php",
    PRIVACY_POLICY:BASE_URL+"/api/privecy-policy.php",
    CASE_STUDY:BASE_URL+"/api/case-study.php",
    GOOGLE_RECAPCHA_VERIFY:BASE_URL+"/api/captcha-verify.php",
    

    


}